import { useCallback, useRef, useState } from 'react';
import { MoreVertical } from 'lucide-react';
import Button from './Button';
import PopoverMenu from './PopoverMenu';

/** @deprecated Prefer variant="icon" size="md" via triggerVariant / triggerSize. */
export const MORE_MENU_TRIGGER_CLASS = '!h-11 !w-11 !min-h-[44px] !min-w-[44px] shrink-0 !px-0';

/**
 * Standard three-dot menu: portaled glass popover + configurable icon trigger.
 */
export default function MoreMenu({
  open: controlledOpen,
  defaultOpen = false,
  onOpenChange,
  ariaLabel = 'More actions',
  placement = 'bottom-end',
  menuClassName = '',
  className = '',
  triggerVariant = 'secondary',
  triggerSize = 'sm',
  triggerClassName = '',
  children,
}) {
  const anchorRef = useRef(null);
  const [internalOpen, setInternalOpen] = useState(defaultOpen);
  const isControlled = controlledOpen !== undefined;
  const open = isControlled ? controlledOpen : internalOpen;
  const isIconTrigger = triggerVariant === 'icon';

  const setOpen = useCallback(
    (next) => {
      if (!isControlled) {
        setInternalOpen(next);
      }
      onOpenChange?.(next);
    },
    [isControlled, onOpenChange],
  );

  const triggerClasses = isIconTrigger
    ? triggerClassName
    : `${MORE_MENU_TRIGGER_CLASS} ${triggerClassName}`.trim();

  return (
    <div className={`relative shrink-0 ${className}`} ref={anchorRef}>
      <Button
        type="button"
        variant={triggerVariant}
        size={triggerSize}
        onClick={() => setOpen(!open)}
        className={triggerClasses || undefined}
        aria-label={ariaLabel}
        aria-expanded={open}
        aria-haspopup="menu"
      >
        <MoreVertical className="h-4 w-4 shrink-0" aria-hidden />
      </Button>
      <PopoverMenu
        open={open}
        onClose={() => setOpen(false)}
        anchorRef={anchorRef}
        placement={placement}
        className={menuClassName}
      >
        {children}
      </PopoverMenu>
    </div>
  );
}
